import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../offer-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function OfferObjectives(props) {
  const { offer } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="Learning Objectives"
      icon={DocumentTextIcon}
      subtitle={offer.data.objective || '(not provided)'}
      onClick={() => history.push(Urls(offer).OBJECTIVES)}
    />
  );
};
